import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IIap } from '~/types/iap'

import { IapStatusBadge } from '~/components/Badges'

const IapStatusCellRenderer = ({ value }: ICellRendererParams<IIap, IIap['status']>): ReactElement => {
  return value ? <IapStatusBadge value={value} /> : <div />
}

export default IapStatusCellRenderer
